import {post} from "../modules/ajax";

let ajaxMenuHtml = null;
export function getMenuHtmlById(id)
{
    if (ajaxMenuHtml) ajaxMenuHtml.abort();

    return new Promise(resolve => {
        ajaxMenuHtml = post(
            '/ajax/website/left-menu/get-menu-html',
            {id: id},
            function(data) {
                ajaxMenuHtml = null;
                resolve(data.html);
            },
            function() {
                ajaxMenuHtml = null;
                resolve(null);
            }
        );
    });
}

export function getMenusHtmlByIds(ids)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/left-menu/get-menus-html',
            {ids: ids},
            function(data) {
                resolve(data.html);
            },
            function() {
                resolve(null);
            }
        );
    });
}
